/***
*
*   BILLING 
*   Update card details
*
**********/

import React, { useState, useEffect } from 'react';
import { Card, CreditCard, PaymentForm, useAPI } from 'components/lib';

export function BillingCard(props){

  const [card, setCard] = useState(null);
  const data = useAPI('/api/billing/card');

  useEffect(() => {

    if (data.data)
      setCard(data.data)

  }, [data.data])

  return (
    <Card mediumWidth loading={ data.loading } className={ props.className }>

      { card && 
        <CreditCard 
          brand={ card.brand }
          last_four={ card.last4 }
          expires={ `${card.exp_month}/${card.exp_year}`}
        />
      } 

      <PaymentForm
        className='restrict-width'
        data={{
          token: {
          label: 'Update Your Card',
          type: 'creditcard',
          required: true
        }}}
        url='/api/billing/card'
        method='PATCH'
        callback={ res => setCard(res.data.data) }
        buttonText='Save Card'
      />

    </Card>
  )
}